interface CustomIconCatiChannelProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconCatiChannel({ width, height }: CustomIconCatiChannelProps) {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="#1C1C28"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5.996 5.583c2.237-1.567 3.678-1.953 5.05.446 1.56 2.724 1.829 4.971.16 6.722-.352.37 1.432 3.996 5.351 7.582.946.544 1.055.012 2.613-.694 2.337-1.058 5.595 2.67 5.522 4.08-.042.81-1.43 3.273-3.283 3.821-4.592 1.358-11.965-6.646-15.233-13.359-1.055-2.168-2.094-4.701-1.942-6.066.102-.91.69-1.754 1.762-2.532Z"
        clipRule="evenodd"
      />
      <path
        stroke="#1C1C28"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5.967 5.858s1.322 3.305 2.644 4.627M20.193 13.532c.048-.362-.105-1.44-.661-2.238-.603-.865-1.015-1.095-1.431-1.315M24.36 16.473c.146-1.086-.315-4.324-1.982-6.714-1.81-2.594-3.044-3.286-4.294-3.946"
      />
    </svg>
  );
}
